<div class="pi-modal-pasos" role="dialog" aria-labelledby="pi-modal-revisa-pasos-title">
  <header class="pi-modal-pasos__header" [class.pi-modal-pasos__header--scrolled]="isScrolled">
    <div class="pi-modal-pasos__header-text">
      <h2 id="pi-modal-revisa-pasos-title" class="pi-modal-pasos__title">
        Pasos para presentar tu<span class="pi-modal-pasos__title-br" aria-hidden="true"></span>solicitud
      </h2>
    </div>
    <ds-icon-button-v2
      class="pi-modal-pasos__close"
      icon="Close"
      size="s"
      emphasis="terciary"
      ariaLabel="Cerrar"
      (clicked)="cerrar()">
    </ds-icon-button-v2>
  </header>

  <div class="pi-modal-pasos__body" (scroll)="onScroll($event)">
    <div class="pi-modal-pasos__content">
      <div class="pi-modal-pasos__video-wrap" *ngIf="videoUrl$ | async as videoUrl">
        <iframe
          class="pi-modal-pasos__video"
          [src]="videoUrl"
          title="Tutorial: Solicitud Pensión de Invalidez"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
          loading="lazy"
          referrerpolicy="strict-origin-when-cross-origin">
        </iframe>
      </div>

      <ol class="pi-modal-pasos__steps">
        <li
          *ngFor="let paso of pasos; let i = index; let first = first; let last = last"
          class="pi-modal-pasos__step">
          <div class="pi-modal-pasos__rail" aria-hidden="true">
            <span
              class="pi-modal-pasos__line pi-modal-pasos__line--in"
              [class.pi-modal-pasos__line--hidden]="first">
            </span>
            <span class="pi-modal-pasos__dot-area">
              <span class="pi-modal-pasos__dot">{{ i + 1 }}</span>
            </span>
            <span
              class="pi-modal-pasos__line pi-modal-pasos__line--out"
              [class.pi-modal-pasos__line--hidden]="last">
            </span>
          </div>

          <div class="pi-modal-pasos__step-content">
            <div class="pi-modal-pasos__text-zone">
              <p class="pi-modal-pasos__step-title">{{ paso.title }}</p>
              <p class="pi-modal-pasos__step-desc">{{ paso.description }}</p>
            </div>
          </div>
        </li>
      </ol>
    </div>
  </div>
</div>
